/* eslint-disable operator-assignment */
export default function modeloRegresion(cards) {
  if (!cards || cards.length === 0) return () => {}
  const n = cards.length
  const datos = cards.map((card) => ({
      x: +card.vneto == 0 ? 0 : +card.vpercibido / (+card.vneto / 1000),
      y: +card.unidades,
    }))

  // componente a
  let a = 0
  // componente b
  let b = 0
  let bx = 0
  let by = 0
  // componente c
  let c = 0
  let cx = 0
  // componente d
  let d = 0
  datos.forEach((dato) => {
    a += dato.y * dato.x
    bx += dato.x
    by += dato.y
    cx += dato.x * dato.x
  })
  a = n * a
  b = bx * by
  c = n * cx
  d = bx * bx

  const m = (a - b) / (c - d)

  const e = by
  const f = m * bx
  const interB = (e - f) / n

  // console.log(`${m}*x + ${interB}`)
  const Fx = (x, y) => +y == 0
      ? 0
      : (m * +x) / (+y / 1000) + interB > 0
      ? (m * +x) / (+y / 1000) + interB
      : 0
  return Fx
}
